module.exports = __webpack_public_path__ + "img/tbt312-3-1993.prt.c5b7c319.jpg";